import React, { useState, useEffect } from "react";
import { getGeneratorWorkoutData} from "./generatorData";
import Dropdown from "../dropdown";


const WorkoutView = () => {
  const [fitnessLevel, setFitnessLevel] = useState([]);
  const [focusArea, setFocusArea] = useState([]);
  const [equipment, setEquipment] = useState([]);
  const [injuries, setInjuries] = useState([]);
  const [workoutReturnPlan, setWorkoutPlan] = useState(null); 

  // const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [isFitnessDropdownOpen, setFitnessDropdownOpen] = useState(false);
  const [isFocusDropdownOpen, setFocusDropdownOpen] = useState(false);
  const [isEquipmentDropdownOpen, setEquipmentDropdownOpen] = useState(false);
  const [isInjuriesDropdownOpen, setInjuriesDropdownOpen] = useState(false);
  
  const [generatorData, setGeneratorData] = useState(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  
  useEffect(() => {
    const token = localStorage.getItem("authToken");
  
    if (!token) {
      console.log("User not authenticated — skipping data load");
      return;
    }
  
    getGeneratorWorkoutData()
      .then((data) => {
        setGeneratorData(data);
        setIsDataLoaded(true);
      })
      .catch((error) => {
        console.error("Error loading generator data:", error);
      });
  }, []);
  
  
  // useEffect(() => {
  //   dataLoaded.then(() => {
  //     console.log("Data has been loaded:", GeneratorWorkoutData);
  //     setIsDataLoaded(true);
  //   }).catch(error => {
  //     console.error("Error loading workout data:", error);
  //   });
  // }, []);

  const toggleDropdown = (type) => {
    console.log(`Toggling dropdown for: ${type}`);
    setFitnessDropdownOpen(type === "fitness" ? !isFitnessDropdownOpen : false);
    setFocusDropdownOpen(type === "focus" ? !isFocusDropdownOpen : false);
    setEquipmentDropdownOpen(type === "equipment" ? !isEquipmentDropdownOpen : false);
    setInjuriesDropdownOpen(type === "injuries" ? !isInjuriesDropdownOpen : false);
  };

  const handleSelection = (type, value) => {
    const updateSelection = (currentItems, setValue) => {
      if (currentItems.includes(value)) {
        setValue(currentItems.filter(item => item !== value));
      } else {
        setValue([...currentItems, value]);
      }
    };
  
    switch (type) {
      case "fitness":
        setFitnessLevel([value]); 
        setFitnessDropdownOpen(false);
        break;
      case "focus":
        updateSelection(focusArea, setFocusArea);
        setFocusDropdownOpen(false);
        break;
      case "equipment":
        updateSelection(equipment, setEquipment);
        setEquipmentDropdownOpen(false);
        break;
      case "injuries":
        updateSelection(injuries, setInjuries);
        setInjuriesDropdownOpen(false); 
        break;
      default:
        break;
    }
  };

  return (
      <div className="section">
          {/* <div className="list-container"> */}
            <div className="list-content">
              {/* Fitness Level */}
              <div className="input-group">
                <h4>Fitness Level</h4>
                <div className="select-container">
                  <div className="selected-pills" id="fitness-pills">
                    {fitnessLevel.map((item, index) => (
                      <span key={index} className="pill">
                        {item}
                        <span 
                          className="remove-pill" 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelection("fitness", item);
                          }}
                        >
                          ×
                        </span>
                      </span>
                    ))}
                  </div> 
                  <div
                    className="dropdown-input"
                    onClick={() => toggleDropdown("fitness")}
                  >
                    <input
                      type="text"
                      placeholder="Select Fitness Level"
                      readOnly
                      value={fitnessLevel.join(", ")}
                    />
                    <span className="dropdown-arrow">▼</span>
                  </div>
                  {isFitnessDropdownOpen && (
                    <Dropdown
                      items={generatorData?.fitness || []}
                      // items={GeneratorWorkoutData.fitness}  
                      type="fitness"
                      selectedItems={fitnessLevel}
                      onItemClick={handleSelection}
                      isOpen={isFitnessDropdownOpen}
                    />
                  )}
                </div>
              </div>

              {/* Area of Focus */}
              <div className="input-group">
                <h4>Area of Focus</h4>
                <div className="select-container">
                  <div className="selected-pills" id="focus-pills">
                    {focusArea.map((item, index) => (
                      <span key={index} className="pill">
                        {item}
                        <span 
                          className="remove-pill" 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelection(" focus", item);
                          }}
                        >
                          ×
                        </span>
                      </span>
                    ))}
                  </div>
                  <div
                    className="dropdown-input"
                    onClick={() => toggleDropdown("focus")}
                  >
                    <input 
                      type="text" 
                      placeholder="Select Focus Area" 
                      readOnly
                      value={focusArea.join(", ")}
                    />
                    <span className="dropdown-arrow">▼</span>
                  </div>
                  {isFocusDropdownOpen && (
                    <Dropdown
                      items={generatorData?.focus || []}
                      // items={GeneratorWorkoutData.focus}  
                      type="focus"
                      selectedItems={focusArea}
                      onItemClick={handleSelection}
                      isOpen={isFocusDropdownOpen}
                    />
                  )}
                </div>
              </div>

              {/* Equipment */}
              <div className="input-group">
                <h4>Equipment</h4>
                <div className="select-container">
                  <div className="selected-pills" id="equipment-pills">
                    {equipment.map((item, index) => (
                      <span key={index} className="pill">
                        {item}
                        <span 
                          className="remove-pill" 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelection("equipment", item);
                          }}
                        >
                          ×
                        </span>
                      </span>
                    ))}
                  </div>
                  <div
                    className="dropdown-input"
                    onClick={() => toggleDropdown("equipment")}
                  >
                    <input 
                      type="text" 
                      placeholder="Select Equipment" 
                      readOnly
                      value={equipment.join(", ")}
                    />
                    <span className="dropdown-arrow">▼</span>
                  </div>
                  {isEquipmentDropdownOpen && (
                    
                    <Dropdown
                    items={generatorData?.equipment || []}
                      // items={GeneratorWorkoutData.equipment}  
                      type="equipment"
                      selectedItems={equipment}
                      onItemClick={handleSelection}
                      isOpen={isEquipmentDropdownOpen}
                    />
                  )}
                </div>
              </div>

              {/* Injuries */}
              <div className="input-group">
                <h4>Injuries</h4>
                <div className="select-container">
                  <div className="selected-pills">
                    {injuries.map((item, index) => (
                      <span key={index} className="pill">
                        {item}
                        <span 
                          className="remove-pill" 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelection("injuries", item);
                          }}
                        >
                          ×
                        </span>
                      </span>
                    ))}
                  </div>
                  <div
                    className="dropdown-input"
                    onClick={() => toggleDropdown("injuries")}
                  >
                    <input 
                      type="text" 
                      placeholder="Select Injuries" 
                      readOnly
                      value={injuries.join(", ")}
                    />
                    <span className="dropdown-arrow">▼</span>
                  </div>
                  {isInjuriesDropdownOpen && (
                    <Dropdown
                    items={generatorData?.injuries || []}
                      // items={GeneratorWorkoutData.injuries}  
                      type="injuries"
                      selectedItems={injuries}
                      onItemClick={handleSelection}
                      isOpen={isInjuriesDropdownOpen}
                    />
                  )}
                </div>
              </div>
            </div>
    </div>
  );
};

export default WorkoutView;